<template>
  <div class="statistical-page">
    <div class="assessment_header">
      <span class="assessment_header">视频分析</span>
      <div class="tabs">
        <div
          class="tabs_item"
          :class="{ 'is-active': tabs === 'analysis' }"
          @click="tabs = 'analysis'"
        >
          视频分析
        </div>
        <div
          class="tabs_item"
          :class="{ 'is-active': tabs === 'video' }"
          @click="tabs = 'video'"
        >
          视频资料
        </div>
      </div>
    </div>
    <div class="item-container">
      <analysis
        v-if="tabs === 'analysis' && videoData.clips"
        :videoData="videoData.clips"
      ></analysis>
      <cl-no-data v-if="tabs === 'analysis' && !videoData.clips"></cl-no-data>

      <videoList
        v-if="tabs === 'video' && videoData.videos"
        :videoList="videoData.videos"
      ></videoList>
      <cl-no-data v-if="tabs === 'video' && !videoData.videos"></cl-no-data>
    </div>
  </div>
</template>

<script>
import analysis from "./analysis.vue";
import videoList from "./video-list.vue";

export default {
  components: {
    videoList,
    analysis,
  },
  props: {
    videoData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tabs: "analysis",
    };
  },
  methods: {
    changeDate() {},
  },
};
</script>
  
<style lang="scss" scoped>
@import "../common-style.scss";
</style>